import { Close as CloseIcon } from '@mui/icons-material';
import { Container, Dialog } from '@mui/material';
import alert from 'assets/icons/alert.svg';
import { useStoreSelector } from 'v3/data/store';
import {
  setCancelationErrorModalOpen,
  setCancelationModalOpen,
  setCurrentCancellationState,
} from 'v3/data/store/cancellationNavigation/actions';
import { AlignIcon, Icon, TitleSection } from 'v3/pages/OnlineContracting/Cancellation/styles';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import {
  confirmationDialogPaperPropsStyle,
  StyledDialogContent,
  StyledIconButton,
} from 'v3/shared/components/Modal/SellerCodeModal/styles';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';

export const CancellationErrorNotification = () => {
  const { isCancellationErrorDialogOpen, currentCancelationState } = useStoreSelector(
    (state) => state.cancellationNavigation,
  );

  const handleRetry = () => {
    setCancelationErrorModalOpen(false);
    setCurrentCancellationState(currentCancelationState);
  };

  const handleClose = () => {
    setCancelationErrorModalOpen(false);
    setCancelationModalOpen(false);
  };

  return (
    <Dialog open={isCancellationErrorDialogOpen} PaperProps={{ sx: confirmationDialogPaperPropsStyle }}>
      <StyledIconButton onClick={handleClose}>
        <CloseIcon />
      </StyledIconButton>
      <StyledDialogContent>
        <AlignIcon>
          <Icon src={alert} alt="Alert" />
        </AlignIcon>
        <TitleSection>
          <HeadlineSmall>Estamos enfrentando problemas para fazer a solicitação</HeadlineSmall>
        </TitleSection>
        <Container>
          <FlexButton text="Tentar novamente" size="small" handleClick={handleRetry} />
        </Container>
      </StyledDialogContent>
    </Dialog>
  );
};
